export const DEFAULT_DEPARTMENT_ID = 99;
